module.exports = __webpack_public_path__ + "static/media/truck.5b9ce67d.svg";